import { useQuasar } from "quasar";
import PDialogForm from "src/components/PDialogForm.vue";
import { unref } from "vue";

export function useCancel({ closeForm, formData }) {
  const $q = useQuasar();

  const { cancelPaymentRequest } = usePaymentRequestStore();

  const loading = ref(false);

  const onConfirm = async (dialog, reason) => {
    try {
      loading.value = true;

      const payload = {
        _id: unref(formData)._id,
        reason: unref(reason),
      };

      await cancelPaymentRequest(payload);

      closeForm();

      dialog?.hide();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const confirmCancel = () => {
    const cancelDialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: `Cancel Payment Request ${unref(formData)?.internal_number}`,
        submitLabel: "Submit",
        cancellable: false,
        loading,
        form: {
          input: {
            type: "textarea",
            autogrow: true,
            required: true,
            placeholder: "Enter Reason",
            label: "Cancel Reason",
            labelClasses: "text-sm text-neutral text-weight-bold",
            help: "Please state the reason to cancel this payment request",
            helpClasses: "text-sm text-neutral-70 q-mt-none",
          },
        },
        onConfirm: (reason) => onConfirm(cancelDialog, reason),
      },
    });
  };

  const cancelButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Cancel",
      type: "button",
      onClick: confirmCancel,
    };
  });

  return {
    cancelButton,
  };
}
